import { useMutation, MutationHookOptions, gql } from "@apollo/client"

const UpdateGpTerminationMutation = gql`
  mutation UpdateGpTermination(
    $terminationId: ID!
    $offboardingCategoryId: ID
    $lastWorkingDay: ISO8601Date
    $lastDayOn: ISO8601Date
    $ptoAccurate: Boolean
    $ptoDaysRemaining: Float
    $mutualTermination: Boolean
    $otherPayments: Boolean
    $additionalTerminationPayments: [AdditionalTerminationPaymentInput!]
    $notes: String
    $notifyCustomerAdmin: Boolean
    $state: TerminationState
    $roeCode: String
    $payrollPayoutMonthChange: Boolean
    $deductNegativePto: Boolean
    $payrollPayoutMonthReason: String
    $proposedPayoutMonth: ISO8601Date
  ) {
    updateGpTermination(
      input: {
        terminationId: $terminationId
        offboardingCategoryId: $offboardingCategoryId
        lastWorkingDay: $lastWorkingDay
        lastDayOn: $lastDayOn
        ptoAccurate: $ptoAccurate
        ptoDaysRemaining: $ptoDaysRemaining
        mutualTermination: $mutualTermination
        otherPayments: $otherPayments
        additionalTerminationPayments: $additionalTerminationPayments
        notes: $notes
        notifyCustomerAdmin: $notifyCustomerAdmin
        state: $state
        roeCode: $roeCode
        payrollPayoutMonthChange: $payrollPayoutMonthChange
        deductNegativePto: $deductNegativePto
        payrollPayoutMonthReason: $payrollPayoutMonthReason
        proposedPayoutMonth: $proposedPayoutMonth
      }
    ) {
      errors
    }
  }
`

export const useUpdateGpTermination = (options?: MutationHookOptions) => {
  return useMutation(UpdateGpTerminationMutation, options)
}
